/* import __COLOCATED_TEMPLATE__ from './list-icons.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();